export var ReservationDriverRole;
(function (ReservationDriverRole) {
    ReservationDriverRole["CONTRACTOR"] = "CONTRACTOR";
    ReservationDriverRole["DRIVER"] = "DRIVER";
})(ReservationDriverRole || (ReservationDriverRole = {}));
